// Application Configuration
// Update these URLs when deploying to production

export const APP_URLS = {
  // Flutter Web App URL - Points to app.batilink.tn subdomain
  // Vercel project: https://app-batilink.vercel.app (then mapped to app.batilink.tn via DNS)
  FLUTTER_WEB_APP: process.env.REACT_APP_FLUTTER_URL || 'https://app.batilink.tn',
  
  // Google Play Store
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.batilink.app',
  
  // Apple App Store
  APP_STORE: 'https://apps.apple.com/us/app/batilink/id6756313346',
  
  // WhatsApp Contact
  WHATSAPP: 'https://wa.me/21629342131',
};

export default APP_URLS;
